import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-sheet',
  templateUrl: './registration-sheet.component.html',
  styleUrls: ['./registration-sheet.component.css']
})
export class RegistrationSheetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
